import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { StockSelectComponent } from '@shared-feature/components/select/stock-select/stock-select.component';
import isNumber from 'lodash/isNumber';

@Component({
  selector: 'app-stock-item-range',
  templateUrl: './stock-item-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockItemsRangeComponent implements OnChanges {
  @ViewChild('to') toSelect!: StockSelectComponent;
  @ViewChild('from') fromSelect!: StockSelectComponent;
  @Input() from: any = null;
  @Input() to: any = null;
  @Input() showStockControlOnly: boolean = false;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['from'].currentValue && isNumber(changes['from'].currentValue)) {
      this.from = null;
    }
  }
}
